import { Icon } from "@jobber/components/Icon";
import { Text } from "@jobber/components/Text";
import styles from "./BackToJobber.module.scss";

type Props = {
  url: string;
  label: string;
};

const BackToJobber = ({ url, label }: Props) => {
  return (
    <div className={styles.container}>
      <a href={url}>
        <Icon name="backArrow" />
        <Text>{ label }</Text>
      </a>
    </div>
  );
};

export default BackToJobber;
